import React from 'react';
import { Box, IconButton, Tooltip, Chip } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import RestoreIcon from '@mui/icons-material/Restore';
import FirebaseStatusIndicator from '../../../components/Common/FirebaseStatusIndicator';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';

export const getStaffColumns = ({ hasPermission, handleDelete, handleReactivate, handlePermanentDelete, handleSingleSignup, handleSingleRemoveSignup, isLoading }) => [
    { accessor: 'staffInfo.employeeId', header: 'Employee ID', render: (row) => row.staffInfo?.employeeId || 'N/A' },
    { accessor: 'user.firstName', header: 'First Name', render: (row) => row.user?.firstName || row.firstName || 'N/A' },
    { accessor: 'user.lastName', header: 'Last Name', render: (row) => row.user?.lastName || row.lastName || 'N/A' },
    { accessor: 'user.gender', header: 'Gender', render: (row) => row.user?.gender || row.gender || 'N/A' },
    {
        accessor: 'user.dateOfBirth',
        header: 'Date of Birth',
        render: (row) => {
            const dob = row.user?.dateOfBirth || row.dateOfBirth;
            return dob ? new Date(dob).toLocaleDateString() : 'N/A';
        }
    },
    { accessor: 'user.phoneNumber', header: 'Phone', render: (row) => row.user?.phoneNumber || row.phoneNumber || 'N/A' },
    { accessor: 'user.email', header: 'Email', render: (row) => row.user?.email || row.email || 'N/A' },
    {
        header: 'Status',
        accessor: 'userStatus',
        render: (row) => {
            const status = row.user?.userStatus || row.userStatus || 'ACTIVE';
            const isInactive = status === 'INACTIVE' || status === 'inactive';
            return (
                <Chip
                    label={isInactive ? 'Disabled' : 'Active'}
                    size="small"
                    sx={{
                        bgcolor: isInactive ? '#f1f5f9' : '#e6f4ea',
                        color: isInactive ? '#64748b' : '#137333',
                        fontWeight: 600,
                        border: `1px solid ${isInactive ? '#cbd5e1' : '#ceead6'}`,
                        fontFamily: 'var(--app-font)'
                    }}
                />
            );
        }
    },
    {
        header: 'Login Access',
        accessor: 'portalAccess',
        render: (row) => <FirebaseStatusIndicator email={row.user?.email || row.email} />
    },
    { accessor: 'user.addressDetails.0.city', header: 'City', render: (row) => row.user?.addressDetails?.[0]?.city || row.addressDetails?.[0]?.city || 'N/A' },
    {
        header: 'Actions',
        render: (row) => {
            const status = row.user?.userStatus || row.userStatus || 'ACTIVE';
            const isInactive = status === 'INACTIVE' || status === 'inactive';
            return (
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                    {isInactive ? (
                        hasPermission('FACULTY', 'DELETE') && (
                            <>
                                <Tooltip title="Reactivate User">
                                    <IconButton
                                        size="small"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleReactivate(row.userId || row.user?.userId);
                                        }}
                                        disabled={isLoading}
                                        sx={{ color: 'success.main' }}
                                    >
                                        <RestoreIcon />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="Delete Permanently">
                                    <IconButton
                                        size="small"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handlePermanentDelete(row.userId || row.user?.userId, row.email || row.user?.email);
                                        }}
                                        disabled={isLoading}
                                        sx={{ color: 'error.main' }}
                                    >
                                        <DeleteIcon />
                                    </IconButton>
                                </Tooltip>
                            </>
                        )
                    ) : (
                        hasPermission('FACULTY', 'DELETE') && (
                            <Tooltip title="Deactivate User">
                                <IconButton
                                    size="small"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleDelete(row.userId || row.user?.userId, row.email || row.user?.email);
                                    }}
                                    disabled={isLoading}
                                >
                                    <DeleteIcon />
                                </IconButton>
                            </Tooltip>
                        )
                    )}
                </Box>
            );
        },
        style: { padding: '6px' },
    },
];
